export const uploadingProgress = (setProgress) => {
  const progressGrowSize = 10;
  const delayGrowFactor = .1;
  let delay = 10;
  let fakeProgress = 0;
  let timerId = setTimeout(function request() {
    fakeProgress += progressGrowSize;
    setProgress(fakeProgress);
    if (fakeProgress < 100) {
      delay *= delayGrowFactor;
      timerId = setTimeout(request, delay);
    } else {
      clearTimeout(timerId);
    }
  }, delay);
};
